import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Fact.module.css';

export interface FactProps {
  label: ReactNode;
  value: ReactNode;
  help?: ReactNode;
  action?: ReactNode;
  /** 0 to 100, shown as a bar under the value. */
  bar?: number;
}

export function Fact({ label, value, help, action, bar }: FactProps) {
  const { t } = useTranslation();
  const pct = bar === undefined ? null : Math.min(100, Math.max(0, Math.round(bar)));

  return (
    <div className={classes.fact}>
      <span className={classes.label}>{label}</span>
      <span className={classes.value}>{value}</span>
      {pct !== null && (
        <div className={classes.track} role="img" aria-label={t('ui.percentUsed', { value: pct })}>
          <div className={classes.fill} style={{ width: `${pct}%` }} />
        </div>
      )}
      {help && <span className={classes.help}>{help}</span>}
      {action && <div className={classes.action}>{action}</div>}
    </div>
  );
}

/** The responsive grid the design lays Facts out in. */
export function FactGrid({ children }: { children: ReactNode }) {
  return <div className={classes.grid}>{children}</div>;
}
